/** @module config/transitionWords */

export const singleWords = [ "også", "fortsatt", "derimot", "derfor", "faktisk", "endelig", "likevel", "følgelig", "likeså", "dessuten", "selvsagt",
	"deretter", "men", "for", "fordi", "mens", "bare", "da", "dog", "enn", "ettersom", "før", "hvorpå", "inntil", "når", "omennskjønt", "samt",
	"som", "uaktet", "pga.", "uansett", "foruten", "siden", "m.a.o", "attpåtil", "derved", "følgelig", "forøvrig", "iallfall", "imidlertid",
	"især", "likefullt", "likeledes", "likeså", "likevel", "omsider", "samstundes", "samtidig", "sikkert", "således", "såleis", "særs", "ellers",
	"enda", "dersom", "skjønt", "samme", "eansett", "etterpå", "generelt", "herav", "imens" ];

export const multipleWords = [ "på den andre siden", "for øyeblikket", "i stedet", "i mellomtiden", "til slutt", "i tillegg", "i tilfelle",
	"med mindre", "om enn", "om to strakser", "selv om", "på grunn av", "med hensyn til", "for eksempel", "en gang", "fremfor alt", "i alle fall",
	"i et nøtteskall", "i hvert fall", "i mellomtiden", "med andre ord", "til dømes", "for øvrig", "i ettertid", "så langt", "på tross av",
	"til tross for", "til tross for at ", "for at", "slik at", "i løpet av", "så at", "slik som", "så lenge", "så ofte", "så snart",
	"etter hvert som", "så fremt", "så sant", "i fall", "for så vidt som", "fordi om", "enda om", "trass i at", "hvor så", "hva enn", "hvor enn",
	"sånn at", "som om", "så som", "rett og slett ", "på samme måte", "etter hvert", "av dette følger", "i mellomtiden", "i dette tilfellet",
	"i motsetning til", "som et resultat", "like viktig", "på grunn av det", "på den positive siden", "på den negative siden", "tvert imot",
	"kort oppsummert", "i begge tilfeller" ];

export const allWords = singleWords.concat( multipleWords );

export default allWords;

